module.exports = __webpack_public_path__ + "static/img/公众号.0fdc3fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/公众号.jpg
// module id = 5+YW
// module chunks = 11